import React from "react";

const PlanCard = ({ title, features, cta, whatsappMessage }) => {
  const whatsappLink = `https://wa.me/5518997958480?text=${encodeURIComponent(
    whatsappMessage
  )}`;

  return (
    <div className="plan-card">
      <h3>{title}</h3>
      <p className="monthly-tag">Mensal</p>
      <ul className="features">
        {features.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-cta"
      >
        {cta}
      </a>
    </div>
  );
};

export default PlanCard;
